import './App.css';

const ThanksPage = () => {
  return (
    <div className="thanks-page">
      <img src="https://bestanimations.com/media/roses/281761993garden-roses-swaying-gif.gif" alt="Roses" className="roses"/>
      <div className="overlay">
        <p className="thanks">Thanks for being my Valentine!</p>
      </div>
    </div>
  );
};

export default ThanksPage;